import { useState } from "react";
import Draggable from "react-draggable";
import "./LegendComponent.css";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { assets } from "../../../publics/assets";
import FilterNoneOutlinedIcon from "@mui/icons-material/FilterNoneOutlined";
import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import { LEGEND_SECTIONS } from "../../../constants/Legendconfig";

const LegendComponent = ({
  handleLegendComponentToggle,
  showSoilMoisture,
  showRegions,
  showDepartements,
  showBareSoil,
  showShrubland,
  showCropland,
  showGrassland,
  showConiferous,
  showBroadleaf,
  showMixedForest,
  showPine,
  showOak,
  showBiomass,
  showLai,
  showTotalFuelLoad,
  showVegHeight,
  showWater,
  showArtificielWater,
  showUrban,
  showWindSpeedData,
  showElectricalLines,
  showElectricalStations,
  showMajorRoads,
  currentZoom,
  showLegendComponent,
  isSmallScreen,
  onShowNavbarMenu,
  showRailways,
  showGazLines,
  showGazRefuelingStations,
  showPrecipitations,
  showHourlyPrecipitations,
  showTemperature,
  showRelativeHumidity,
  showMeanSeaLevelPressure,
  showWindGust,
  showFireStations,
  geoJsonResults,
  onReduceLegendWindow,
  reducedLegendWindow,
  showDem,
  showDeadFuel,
  showCloudCover,
  closeAllLayers,
  showDfci,
  showActiveFires,
  showHistoricFires,
}) => {
  const [activeDrags, setActiveDrags] = useState(0);
  const [deltaPosition, setDeltaPosition] = useState({ x: 0, y: 0 });
  const [activePopup, setActivePopup] = useState(null);

  const togglePopup = (popupId) => {
    setActivePopup((current) => (current === popupId ? null : popupId));
  };

  const handleStart = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setActiveDrags((prev) => prev + 1);
  };

  const handleDrag = (e, data) => {
    e.stopPropagation();
    e.preventDefault();
    setDeltaPosition({
      x: deltaPosition.x + data.deltaX,
      y: deltaPosition.y + data.deltaY,
    });
  };

  const handleStop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setActiveDrags((prev) => prev - 1);
  };

  const returnToMenu = () => {
    handleLegendComponentToggle();
    onShowNavbarMenu();
  };

  // Helper function to check if an item should be shown based on its show property
  const shouldShowItem = (item) => {
    switch (item.show) {
      case "showSoilMoisture":
        return showSoilMoisture;
      case "showRegions":
        return showRegions;
      case "showDepartements":
        return showDepartements;
      case "showBareSoil":
        return showBareSoil;
      case "showShrubland":
        return showShrubland;
      case "showCropland":
        return showCropland;
      case "showGrassland":
        return showGrassland;
      case "showConiferous":
        return showConiferous;
      case "showBroadleaf":
        return showBroadleaf;
      case "showMixedForest":
        return showMixedForest;
      case "showPine":
        return showPine;
      case "showOak":
        return showOak;
      case "showBiomass":
        return showBiomass;
      case "showLai":
        return showLai;
      case "showTotalFuelLoad":
        return showTotalFuelLoad;
      case "showVegHeight":
        return showVegHeight;
      case "showWater":
        return showWater;
      case "showArtificielWater":
        return showArtificielWater;
      case "showUrban":
        return showUrban;
      case "showWindSpeedData":
        return showWindSpeedData;
      case "showElectricalLines":
        return showElectricalLines;
      case "showElectricalStations":
        return showElectricalStations;
      case "showMajorRoads":
        return showMajorRoads;
      case "showRailways":
        return showRailways;
      case "showGazLines":
        return showGazLines;
      case "showGazRefuelingStations":
        return showGazRefuelingStations;
      case "showPrecipitations":
        return showPrecipitations;
      case "showHourlyPrecipitations":
        return showHourlyPrecipitations;
      case "showTemperature":
        return showTemperature;
      case "showRelativeHumidity":
        return showRelativeHumidity;
      case "showMeanSeaLevelPressure":
        return showMeanSeaLevelPressure;
      case "showWindGust":
        return showWindGust;
      case "showFireStations":
        return showFireStations;
      case "showDem":
        return showDem;
      case "showDeadFuel":
        return showDeadFuel;
      case "showCloudCover":
        return showCloudCover;
      case "showDfci":
        return showDfci;
      case "showActiveFires":
        return showActiveFires;
      case "showHistoricFires":
        return showHistoricFires;
      default:
        return false;
    }
  };

  // Check if any item in a group is visible
  const hasVisibleItems = (items) => {
    return items.some((item) => shouldShowItem(item));
  };

  // Group items by section
  const standaloneItems = LEGEND_SECTIONS.filter(
    (item) => item.section === null,
  );
  const sections = {};

  LEGEND_SECTIONS.forEach((item) => {
    if (item.section !== null) {
      if (!sections[item.section]) {
        sections[item.section] = [];
      }
      sections[item.section].push(item);
    }
  });

  // Render functions for different item types
  const renderGradientItem = (item) => (
    <div key={item.id}>
      <p style={{ fontSize: "12px", fontWeight: "600" }}>{item.label}</p>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "11px",
        }}
      >
        {item.ticks.map((tick, index) => (
          <span key={index}>{tick}</span>
        ))}
      </div>
      <div
        style={{
          width: "98%",
          height: "10px",
          background: item.gradient,
          marginTop: "4px",
          borderRadius: "4px",
        }}
      ></div>
      <hr style={{ width: "100%" }} />
    </div>
  );

  const renderLineItem = (item) => (
    <div
      key={item.id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        marginBottom: "5px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          className="line-legend-layers"
          style={{
            backgroundColor: item.color,
            // Add dashed line style if specified
            ...(item.dashed && {
              backgroundImage: `repeating-linear-gradient(90deg, ${item.color}, ${item.color} 5px, transparent 5px, transparent 10px)`,
              backgroundSize: "10px 100%",
              backgroundColor: "transparent",
            }),
          }}
        ></div>
        <p className="legend-item">{item.label}</p>
      </div>
      {item.popupTitle && (
        <>
          <InfoOutlinedIcon
            className={`popup-icon ${activePopup === item.id ? "active" : ""}`}
            onClick={() => togglePopup(item.id)}
            data-testid={`legend-info-icon-${item.id}`}
          />
          {activePopup === item.id && (
            <div
              className="legend-popup"
              data-testid={`legend-popup-${item.id}`}
            >
              <p>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <b>{item.popupTitle}</b>
                  <CloseIcon
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => togglePopup(item.id)}
                    data-testid={`legend-popup-close-${item.id}`}
                  />
                </span>
                {item.popupText}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
  const renderPointItem = (item) => (
    <div
      key={item.id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        marginBottom: "5px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          className="point-legend-layers"
          style={{ backgroundColor: item.color }}
        ></div>
        <span className="legend-item">{item.label}</span>
      </div>
      {item.popupTitle && (
        <>
          <InfoOutlinedIcon
            className={`popup-icon ${activePopup === item.id ? "active" : ""}`}
            onClick={() => togglePopup(item.id)}
          />
          {activePopup === item.id && (
            <div className="legend-popup">
              <p>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <b>{item.popupTitle}</b>
                  <CloseIcon
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => togglePopup(item.id)}
                  />
                </span>
                {item.popupText}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );

  const renderColorItem = (item) => (
    <div
      key={item.id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        marginBottom: "5px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          className="fill-legend-square"
          style={{ backgroundColor: item.color }}
        ></div>
        <span className="legend-item">{item.label}</span>
      </div>
      {item.popupTitle && (
        <>
          <InfoOutlinedIcon
            className={`popup-icon ${activePopup === item.id ? "active" : ""}`}
            onClick={() => togglePopup(item.id)}
          />
          {activePopup === item.id && (
            <div className="legend-popup">
              <p>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <b>{item.popupTitle}</b>
                  <CloseIcon
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => togglePopup(item.id)}
                  />
                </span>
                {item.popupText}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );

  const renderIconItem = (item) => (
    <div
      key={item.id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        marginBottom: "5px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={assets[item.iconKey]}
          style={{ width: `${item.iconSize || 16}px`, marginRight: "16px" }}
        />
        <span className="legend-item">{item.label}</span>
      </div>
      {item.popupTitle && (
        <>
          <InfoOutlinedIcon
            className={`popup-icon ${activePopup === item.id ? "active" : ""}`}
            onClick={() => togglePopup(item.id)}
          />
          {activePopup === item.id && (
            <div className="legend-popup">
              <p>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "3px",
                  }}
                >
                  <b>{item.popupTitle}</b>
                  <CloseIcon
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => togglePopup(item.id)}
                  />
                </span>
                {item.popupText}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );

  const renderRoadItem = (item) => {
    // Check zoom conditions
    if (item.minZoom && currentZoom < item.minZoom) return null;

    return (
      <div
        key={item.id}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          marginBottom: "5px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: "20px",
              height: `${item.thickness || 3}px`,
              backgroundColor: item.color,
              marginRight: "20px",
            }}
          ></div>
          <p className="legend-item">{item.label}</p>
        </div>
        {item.popupTitle && (
          <>
            <InfoOutlinedIcon
              className={`popup-icon ${activePopup === item.id ? "active" : ""}`}
              onClick={() => togglePopup(item.id)}
            />
            {activePopup === item.id && (
              <div className="legend-popup">
                <p>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "3px",
                    }}
                  >
                    <b>{item.popupTitle}</b>
                    <CloseIcon
                      style={{ fontSize: "12px", cursor: "pointer" }}
                      onClick={() => togglePopup(item.id)}
                    />
                  </span>
                  {item.popupText}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const renderItem = (item) => {
    if (!shouldShowItem(item)) return null;

    switch (item.type) {
      case "gradient":
        return renderGradientItem(item);
      case "line":
        return renderLineItem(item);
      case "point":
        return renderPointItem(item);
      case "color":
        return renderColorItem(item);
      case "icon":
        return renderIconItem(item);
      case "road":
        return renderRoadItem(item);
      default:
        return null;
    }
  };

  const renderSection = (sectionName, items) => {
    if (!hasVisibleItems(items)) return null;

    return (
      <div key={sectionName}>
        <p
          style={{
            fontSize: "12px",
            fontWeight: "600",
            marginBottom: "3px",
          }}
        >
          {sectionName}
        </p>
        {items.map((item) => renderItem(item))}
        <hr />
      </div>
    );
  };

  const legendContent = (
    <div className="legend-comp-body">
      {/* Render standalone items first */}
      {standaloneItems.map((item) => renderItem(item))}

      {/* Render sections */}
      {Object.entries(sections).map(([sectionName, items]) =>
        renderSection(sectionName, items),
      )}
      {/* Dynamic buildings section */}
      {geoJsonResults.some((r) => r?.showBuildings) && (
        <div>
          <p
            style={{ fontSize: "12px", fontWeight: "600", marginBottom: "3px" }}
          >
            Bâtiments à Risque
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              marginBottom: "5px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={assets.buildings_t1}
                style={{ width: "22px", marginRight: "16px" }}
              />
              <span className="legend-item">Bâtiments exposés</span>
            </div>
            <InfoOutlinedIcon
              className={`popup-icon ${activePopup === "buildingsRisk" ? "active" : ""}`}
              onClick={() => togglePopup("buildingsRisk")}
              data-testid="legend-info-icon-buildingsRisk"
            />
            {activePopup === "buildingsRisk" && (
              <div
                className="legend-popup"
                data-testid="legend-popup-buildingsRisk"
              >
                <p>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <b>Bâtiments à Risque:</b>
                    <CloseIcon
                      style={{ fontSize: "14px", cursor: "pointer" }}
                      onClick={() => togglePopup("buildingsRisk")}
                      data-testid="legend-popup-close-buildingsRisk"
                    />
                  </span>
                  <br /> Structures situées dans les zones de propagation
                  prévues du feu, identifiées selon les contours de simulation.
                </p>
              </div>
            )}
          </div>
          <hr />
        </div>
      )}
    </div>
  );

  return (
    <>
      {isSmallScreen ? (
        <div
          className={`sidebar-draggableComp ${
            showLegendComponent ? "open" : ""
          }`}
          data-testid="legend-sidebar-mobile"
        >
          <div className="drag-comp-header">
            <KeyboardDoubleArrowLeftIcon
              onClick={returnToMenu}
              className="drag-comp-returnIcon"
              data-testid="legend-return-icon"
            />
            <div className="drag-comp-title">Légende</div>
            <div className="drag-header-icons">
              <button
                onClick={closeAllLayers}
                title="Fermer toutes les couches"
                className="tout-fermer-btn"
                data-testid="legend-close-all-button"
              >
                <CloseIcon
                  className="tout-fermer-icon"
                  style={{ fontSize: "12px" }}
                />
                <span>Tout fermer</span>
              </button>

              <CloseIcon
                onClick={handleLegendComponentToggle}
                className="drag-comp-closeIcon"
                data-testid="legend-close-icon"
              />
            </div>
          </div>
          {legendContent}
        </div>
      ) : (
        <Draggable
          handle=".handle"
          defaultPosition={{ x: -50, y: 50 }}
          position={null}
          grid={[25, 25]}
          scale={1}
          onStart={handleStart}
          onDrag={handleDrag}
          onStop={handleStop}
        >
          <div
            className="legend-comp handle"
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            data-testid="legend-panel-desktop"
          >
            <div className="legend-comp-header">
              <div className="drag-comp-title">Légende</div>
              <div className="drag-header-icons">
                <button
                  onClick={closeAllLayers}
                  title="Fermer toutes les couches"
                  className="tout-fermer-btn"
                  data-testid="legend-close-all-button"
                >
                  <CloseIcon
                    className="tout-fermer-icon"
                    style={{ fontSize: "12px" }}
                  />
                  <span>Tout fermer</span>
                </button>
                {reducedLegendWindow ? (
                  <CropSquareOutlinedIcon
                    onClick={onReduceLegendWindow}
                    className="drag-comp-closeIcon"
                    style={{ fontSize: "20px" }}
                    data-testid="legend-expand-icon"
                  />
                ) : (
                  <FilterNoneOutlinedIcon
                    onClick={onReduceLegendWindow}
                    className="drag-comp-closeIcon"
                    style={{ fontSize: "17px" }}
                    data-testid="legend-reduce-icon"
                  />
                )}
                <CloseIcon
                  onClick={handleLegendComponentToggle}
                  className="drag-comp-closeIcon"
                  data-testid="legend-close-icon"
                />
              </div>
            </div>
            {!reducedLegendWindow && legendContent}
          </div>
        </Draggable>
      )}
    </>
  );
};

export default LegendComponent;
